<template>
    <v-card width="95%" :height="height" class="ma-auto mt-4 rounded-lg">
        <v-row no-gutters>
            <v-col cols="9" align="center" class="pa-0">
                <v-card-title class="d-flex align-center justify-center">Chats
                </v-card-title>
                <v-divider></v-divider>
                <v-card flat :height="height - 125">
                    <v-card-text id="msg-container" v-if="selectedConversation.length > 0">
                        <v-card id="chatContainer" :height="height - 160" class="overflow-y-auto" flat>
                            <div v-for="(msg, index) in selectedConversation" :key="index" class="pa-0 ma-2">
                                <v-container :class="msg.isMe ? 'd-flex justify-start' : 'd-flex justify-end'"
                                    class="pa-0 ma-0">
                                    <v-card class="py-1 px-2 ml-2 white--text text-subtitle-1 text-left" rounded="lg"
                                        :color="msg.isMe ? 'primary' : 'secondary'" max-width="60%" min-width="25%">
                                        <span v-html="msg.text"></span>
                                    </v-card>
                                </v-container>
                            </div>
                        </v-card>
                        <v-divider></v-divider>
                        <v-card-text v-if="getChatStatus === 'inProgress'">
                            <v-btn v-if="getAIResponse" @click="claimConversation()">Stop AI and respond</v-btn>
                            <v-text-field v-else dense
                                label="Click on 'Clear Chat' top right to start a new conversation."
                                v-model="messageReply" append-outer-icon="mdi-send" @click:append-outer="sendMessage"
                                @keyup.enter="sendMessage"></v-text-field>
                        </v-card-text>
                        <v-card-text v-else>
                            Chat has ended.
                        </v-card-text>
                    </v-card-text>

                    <v-card-text class="d-flex align-center justify-center" v-else>
                        <v-row no-gutters>
                            <v-col cols="12" class="d-flex align-center justify-center mt-5">
                                <span class="black--text font-weight-bold justify-center">
                                    Select a conversation to view.
                                </span>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="3" class="pa-0 d-flex align-center justify-center">
                <v-card :height="height" width="100%" flat class="conversationClass">
                    <v-card-title>Conversations</v-card-title>
                    <v-divider></v-divider>
                    <v-list :height="height - 100" class="overflow-y-auto">
                        <v-list-item-group v-model="selected" active-class="primary--text">
                            <div v-for="(room) in rooms" :key="room.id">
                                <v-list-item @click="getRoomInfo(room)">
                                    <v-list-item-content>
                                        <v-list-item-title v-if="room.roomOwner">
                                            {{ room.roomOwner }}
                                        </v-list-item-title>
                                        <v-list-item-title v-else>
                                            Test Kiosk
                                        </v-list-item-title>
                                        <v-list-item-subtitle class="text--primary">{{ room.id }}</v-list-item-subtitle>
                                        <v-list-item-subtitle>{{ room.updatedAt }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                    <v-list-item-action v-if="room.count > 0">
                                        <v-badge color="primary" :content="room.count" inline></v-badge>
                                    </v-list-item-action>
                                </v-list-item>
                                <v-divider></v-divider>
                            </div>
                        </v-list-item-group>
                    </v-list>
                </v-card>
            </v-col>
        </v-row>
    </v-card>
</template>
<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
export default {
    name: "chatsPortal",
    computed: {
        ...mapGetters(["getRooms", "getAIResponse", "userProfile", "getChatStatus", "getNewMessage"]),
        // sortedRooms() {
        //     // helper to parse 12-hour time like "2:58:25 PM"
        //     const parseTime12h = (str) => {
        //         const [time, meridiem] = str.trim().split(/\s+/);
        //         let [h, m, s] = time.split(":").map(Number);
        //         if (s == null) s = 0;
        //         if (/pm/i.test(meridiem) && h !== 12) h += 12;
        //         if (/am/i.test(meridiem) && h === 12) h = 0;
        //         return h * 3600 + m * 60 + s; // convert to seconds for sorting
        //     };

        //     // copy + sort by time descending
        //     return [...this.getRooms].sort(
        //         (a, b) => parseTime12h(b.updatedAt) - parseTime12h(a.updatedAt)
        //     );
        // }
    },
    data() {
        return {
            width: window.innerWidth - 1000,
            height: window.innerHeight - 100,
            selectedConversation: [],
            messageReply: "",
            roomInfo: null,
            selected: null,
            rooms: []
        }
    },
    watch: {
        getAIResponse(newVal) {
            console.log('New Value at Rooms: ', newVal)
            this.roomInfo.aiResponse = newVal
        },
        getChatStatus(newVal) {
            this.roomInfo.chatStatus = newVal
        },
        getNewMessage(newVal) {
            if (newVal) {
                this.sortedRoom()
            }
        }
    },
    methods: {
        sortedRoom() {
            // copy + sort by time descending
            this.rooms = this.getRooms.sort((a, b) => {
                const dateA = moment(a.updatedAt, "MM/DD/YYYY h:mm:ss A");
                const dateB = moment(b.updatedAt, "MM/DD/YYYY h:mm:ss A");
                return dateB - dateA; // descending order
            });
            this.$store.commit("setNewMessage", false)
        },
        getRoomInfo(room) {
            console.log("AT get Room Info: ", room)
            this.roomInfo = room
            if (room.messages.length > 0) {
                this.selectedConversation = room.messages
            }
            this.$store.commit("setChatStatus", room.chatStatus);
            this.$store.commit("setAIResponse", room.aiResponse)
            this.$store.commit("setSelectedRoom", room.id)
            this.getRooms.filter(room1 => room1.id === room.id)[0].count = 0
            
        },
        claimConversation() {
            this.$store.dispatch("claimRoom", this.roomInfo)
        },
        sendMessage() {
            this.$store.dispatch("updateMessage", {
                roomId: this.roomInfo.id,
                message: {
                    isMe: false,
                    text: this.messageReply,
                    date: moment().format('LTS'),
                    responder: this.userProfile.data().name
                }
            })
            this.messageReply = ""
            console.log("Message: ", this.messageReply)
        }
    },
    mounted() {
        this.sortedRoom()
    }
}
</script>
<style>
.conversationClass {
    border-left: 1px solid #BDBDBD !important;
    border-radius: 0px !important;
}
</style>